import React from 'react';
import get from 'lodash/get';
import styled from '@emotion/styled';
import Button from '../../../components/Button';
import { useGlobalContext } from '../../state/GlobalContext';
import { isObject } from 'lodash';

interface OrderNowButtonProps {
  subscription: Subscription;
  subscriptionIsInDunning: boolean;
  orderSubmitted: boolean;
  shouldDisableOrderNowButton: boolean;
  setShowOrderNowConfirmationModal: () => void;
  t: (key: string) => string;
}

const OrderNowButton = ({
  subscription,
  orderSubmitted,
  subscriptionIsInDunning,
  shouldDisableOrderNowButton,
  setShowOrderNowConfirmationModal,
  t,
}: OrderNowButtonProps): React.ReactElement | null => {
  const { customerPortalSettings } = useGlobalContext();

  const isActive = subscription?.SubscriptionStatus === 'ACTIVE';
  const isCancelled = subscription?.SubscriptionStatus === 'CANCELLED';
  const isExpired = subscription?.SubscriptionStatus === 'EXPIRED';
  const isPrepaid =
    !!subscription?.BillingIntervalBillingCount &&
    !!subscription?.DeliveryIntervalDeliveryCount &&
    subscription?.BillingIntervalBillingCount !=
      subscription?.DeliveryIntervalDeliveryCount;
  const isFailed = subscription?.SubscriptionStatus === 'FAILED';
  const anchors = get(subscription, 'DeliveryBatchingAnchor', []);
  const isBatched = anchors.length > 0;
  const isBillingOrUpdatingOrScheduled =
    subscription?.IsBilling ||
    subscription?.IsUpdating ||
    subscription?.IsBillingScheduled;
  const hideOrderNow =
    customerPortalSettings?.hideReschedule ||
    customerPortalSettings?.hideOrderNow;
  const isBatchedV2 =
    (isObject(subscription?.BatchingConfiguration) as any) &&
    subscription?.BatchingConfiguration?.anchor !== '';

  return !isBatchedV2 &&
    !isCancelled &&
    !isExpired &&
    !isPrepaid &&
    !isFailed &&
    !isBatched &&
    !subscriptionIsInDunning &&
    !hideOrderNow ? (
    <CustomButton
      _className="bundle-button--order-now"
      disabled={
        shouldDisableOrderNowButton ||
        isBillingOrUpdatingOrScheduled ||
        orderSubmitted ||
        !isActive
      }
      onClick={setShowOrderNowConfirmationModal}
      outlined
      filled={true}
      fullWidth
    >
      {orderSubmitted
        ? t('subscription.order_submitted')
        : t('subscription.order_now')}
    </CustomButton>
  ) : null;
};

const CustomButton = styled(Button)`
  height: 44px;
  display: flex;
  height: auto;
  justify-content: center;
  align-items: center;
  padding: 8px;
`;

export default OrderNowButton;
